module.exports = __webpack_public_path__ + "static/media/portfolio10.232996c6.png";